import router from '@/router'
import UserService from '@/services/user'

class AuthService {
  public logout(): void {
    UserService.clearUser()
    localStorage.clear()
    sessionStorage.clear()
    router.push({ name: 'home' })
  }
}
export default new AuthService()
